import { render, staticRenderFns } from "./EmptyPattern.vue?vue&type=template&id=39938f47"
var script = {}
import style0 from "./EmptyPattern.vue?vue&type=style&index=0&id=39938f47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports